import { AlmostNullQ } from "@pdfking/forms"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { NullQ } from "@pdfking/structs"
import { Items, RecordCreate } from "@pdfking/tfunc"

import type { FlatChoices } from "#public"

import { SelectMixin } from "../mixins/SelectMixin"
import { DjInput } from "./DjInput"

export const DjDatalist = CreateRenderFunction({
  computed: {
    current_key(): string {
      return NullQ(this.input) ? "" : String(this.input)
    },
    current_label(): string {
      return (this.choices as FlatChoices)[this.current_key] ?? this.current_key
    },
    // Labels only — DjInput's datalist fills whatever the option's `value`
    // is, and the field deals entirely in labels (see select_from_datalist),
    // so the choice keys have no business showing up in the suggestion list.
    label_suggestions(): FlatChoices {
      const labels = Items(this.choices as FlatChoices).map(([, label]) => label)
      return RecordCreate(labels, labels)
    },
  },
  methods: {
    // The input is always blank — the current choice lives in the
    // placeholder — so whatever was typed/picked is cleared by hand on every
    // commit. `onselect` only fires on a real hit; free text that isn't a
    // choice leaves the selection untouched.
    select_from_datalist(label: string) {
      const el = document.getElementById(this.dom_id) as HTMLInputElement | undefined
      if (el) el.value = ""
      const hit = Items(this.choices as FlatChoices).find(([, l]) => l === label)
      if (hit) this.onselect?.(hit[0])
    },
  },
  mixins: [SelectMixin] as const,
  props: {
    input: undefined as unknown,
  },
  render() {
    return (
      <DjInput
        clearable={!AlmostNullQ(this.input)}
        disabled={this.disabled}
        dom_id={this.dom_id}
        // Always blank and ready to type; the current choice shows as the
        // placeholder instead of the value.
        input=""
        placeholder={this.current_label}
        // The X clears the selection, so the placeholder falls back to the
        // empty choice's label (if any). Shown while something is selected,
        // since the input itself is always blank.
        onclear={() => this.onselect?.("")}
        oncommit={this.select_from_datalist}
        suggestions={this.label_suggestions}
      />
    )
  },
})
